import type { SelectFilterState } from '../../../common/constants/filters/select-filter/types';

/**
 * Factory that creates a select filter definition (single, multi, or custom-option)
 * from a filter ID and configuration.
 *
 * Returns a SelectFilter object with methods for state management (getState,
 * setOption, clearOptions), option loading (loadInitialOptions, setLookupInput),
 * and query param generation — all without depending on React hooks.
 *
 * Pure function — safe for SSR and non-React contexts.
 */
export const generateQueryParamsGetState = <ID extends string>(
	initialState: SelectFilterState<ID>,
	queryParamKey: string,
) => {
	return (queryParams: Record<string, string[]>): SelectFilterState<ID> => {
		const queryParamValue = queryParams[queryParamKey];
		return {
			...initialState,
			value: queryParamValue || initialState.value,
		};
	};
};
